import { Individuals } from '@factorin/domain';

import { withUrl, readUpdate } from '../rest';


const individualsPart = withUrl('individuals');

export const individuals = readUpdate<Individuals.Individual>(individualsPart());
